export var ADDON_ID = 'storybook/links';
export var PARAM_KEY = "links";
export default {
  NAVIGATE: "".concat(ADDON_ID, "/navigate"),
  REQUEST: "".concat(ADDON_ID, "/request"),
  RECEIVE: "".concat(ADDON_ID, "/receive")
};